export const MuiIcon = {
  MuiIcon: {
    root: {
      // color:
    },
  },
  MuiSvgIcon: {
    root: {
      // color:
    },
  },
};
